import _ from 'lodash'
import { getCdnHost, CloudResourceType } from '../lib/env-variables'

const CDN_HOST_FORM_PREVIEWS = getCdnHost(CloudResourceType.FORM_PREVIEWS)

export const DEFAULT_LOADERS = _.times(30, (n) => ({
  label: `Animation ${n + 1}`,
  path: `https://${CDN_HOST_FORM_PREVIEWS}/animationpreloaders/animation_${n + 1}.gif`,
}))
